<div class="pre-login">
  <div class="pre-login-col-1 h-100">
    <left-panel-onboarding></left-panel-onboarding>
  </div>
  <div class="pre-login-col-2">
  </div>
  <div class="pre-login-col-3">
    <div class="onboarding-canvas">
      <grid-row class="mt-30">
        <grid-col col="8">
          <!-- <div class="font-400 font-size-20px line-h-25">
            {{ "EnterloanNickname" | translate }}
          </div> -->
          <div class="font-400 font-size-20px line-h-25">
            {{ "EnterCardNickname" | translate }}
          </div>
        </grid-col>
      </grid-row>
      <div class="form-group mt-50">
        <label class="no-mark">
          {{ "loanNickname" | translate }}
        </label>
        <input type="text" placeholder="Please enter"  [(ngModel)]="this.CardName">
      </div>
      <grid-row class="justify-content-between mt-50">
        <grid-col col="auto">
          <button class="btn-back" (click)="back()">
            <i class="icon-back"></i>
          </button>
        </grid-col>
        <grid-col col="6" *ngIf="this.CardName!==''">
          <button class="btn-dft-border p-17" (click)="this.showModal(6)">
            {{ "RemoveNickName" | translate }}
          </button>
        </grid-col>

        <grid-col col="6" *ngIf="this.CardName == ''">
          <button class="btn-dft-border p-17" (click)="updateNickName('')">
            {{ "SAVE" | translate }}
          </button>
        </grid-col>
      </grid-row>
      <grid-row class="justify-content-center mt-24" *ngIf="this.CardName != ''">
        <grid-col col="12">
          <button class="btn-dft"  [disabled]="isValid()" (click)="updateNickName('')">
            {{ "SAVE" | translate }}
          </button>
        </grid-col>
      </grid-row>
    </div>
  </div>
</div>

<!-- Success Card pin Modal Open -->
<modal modalID="6" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="CONFIRM"
  [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="updateNickName('remove')">
  <div class="text-align-center">
    <ng-icon iconClass="icon-remove-modal" width="72" height="72"></ng-icon>
    <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
      {{ "RemoveNickname" | translate }}
    </div>
    <div class="font-400 font-size-14px line-h-20 color-base-500 p-10">
      {{ "AreYouSureToRemoveLoan" | translate }}
    </div>
  </div>
</modal>
<!--Success Card pin  Modal Close  -->